import React from 'react';
import styled from 'styled-components';

const Bar = styled.div`
  position: fixed;
  bottom: 0;
  left: 0; right:0;
  z-index: 1300;
  background: linear-gradient(135deg,var(--theme-secondary,#2196f3),var(--theme-primary,#4caf50));
  color: #fff;
  padding: 14px 18px calc(14px + env(safe-area-inset-bottom,0));
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: 0 -4px 18px rgba(0,0,0,.35);
  font-size: 14px;
`;
const Btn = styled.button`
  background:#fff; color:#222; border:none; font-weight:600; padding:8px 14px; border-radius:10px; cursor:pointer; font-size:14px;
  box-shadow:0 2px 6px rgba(0,0,0,.25);
`;
const Close = styled.button`
  background:rgba(255,255,255,0.2); color:#fff; border:1px solid rgba(255,255,255,0.4); width:34px; height:34px; border-radius:10px; font-size:18px; cursor:pointer;
`;

interface InstallPromptProps {
  daysUntilRepeat?: number;
}

// Lightweight prompt for browsers supporting beforeinstallprompt
const InstallPrompt: React.FC<InstallPromptProps> = ({ daysUntilRepeat = 7 }) => {
  const [deferred, setDeferred] = React.useState<any>(null);
  const [show, setShow] = React.useState(false);

  React.useEffect(() => {
    const key = 'yatzy-install-dismissed-at';
    try {
      const last = localStorage.getItem(key);
      if (last) {
        const days = (Date.now() - parseInt(last,10)) / 86400000;
        if (days < daysUntilRepeat) return; // still cooldown
      }
    } catch {}
    const handler = (e: any) => {
      e.preventDefault();
      setDeferred(e);
      setShow(true);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, [daysUntilRepeat]);

  if (!show) return null;

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    try { await deferred.userChoice; } catch {}
    setShow(false);
  };
  const dismiss = () => {
    setShow(false);
    try { localStorage.setItem('yatzy-install-dismissed-at', Date.now().toString()); } catch {}
  };

  return (
    <Bar role="dialog" aria-label="Installera appen">
      <div style={{flex:1}}><strong>Installera?</strong> Lägg till Yatzy på hemskärmen för snabbare start & fullscreen.</div>
      <Btn onClick={install}>Installera</Btn>
      <Close aria-label="Stäng" onClick={dismiss}>×</Close>
    </Bar>
  );
};

export default InstallPrompt;
